import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";
import { useUser } from "./useUser";

/**
 * Returns the count of pending tasks assigned to the currently logged-in user.
 * Used for badges on the Tasks nav item and dashboard card.
 */
export const usePendingTasksCountForUser = () => {
  const { user } = useUser();
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) {
      setCount(0);
      setLoading(false);
      return;
    }

    const fetchCount = async () => {
      try {
        const { count: pendingCount, error } = await supabase
          .from("tasks")
          .select("id", { count: "exact", head: true })
          .eq("admin_user_id", user.id)
          .eq("completed", false);

        if (error) throw error;
        setCount(pendingCount ?? 0);
      } catch (err) {
        console.error("Error fetching pending tasks count for user:", err);
        setCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchCount();

    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, [user?.id]);

  return { count, loading };
};
